import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { TaskForAsyncTaskFunction } from 'ember-concurrency';
import { task } from 'ember-concurrency';
import type { CentralMappingOrganizationSettings } from 'lumen/models';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';
import SilentTaskError, {
  getErrorMessage,
} from 'lumen/utils/silent-task-error';

export type MarketSettingsCentralMappingMenuModel = {
  mappingPermission: TaskForAsyncTaskFunction<
    { restartable: boolean },
    () => Promise<CentralMappingOrganizationSettings | null>
  >;
};

export default class MarketSettingsCentralMappingMenuRoute extends Route {
  @service declare errorTracking: Services['error-tracking'];
  @service declare store: Services['store'];

  getMappingPermissionTask = task({ restartable: true }, async () => {
    try {
      return await this.store.queryRecord<CentralMappingOrganizationSettings>(
        'central-mapping/organization-settings',
        { namespace: APIGATEWAY },
      );
    } catch (error) {
      this.errorTracking.captureException(error);
      throw new SilentTaskError(getErrorMessage(error));
    }
  });

  model(): MarketSettingsCentralMappingMenuModel {
    void this.getMappingPermissionTask.perform();

    return {
      mappingPermission: this.getMappingPermissionTask,
    };
  }
}
